
<el-row class="aside">
  <el-tabs v-model="filterChosed" class="left-chooser" tab-position="left"> <!--@tab-click="handleClick"-->
    <el-tab-pane name="time">
      <span slot="label">
        <div class="aside-filter-icon"><i class="aside-filter-time"></i></div>
      </span>
    </el-tab-pane>
    <el-tab-pane name="alphabetical">
      <span slot="label">
        <div class="aside-filter-icon aside-filter-icon-bigger"><i class="aside-filter-alphabetical"></i></div>
      </span>
    </el-tab-pane>
    <el-tab-pane name="new">
      <span slot="label">
        <div class="aside-filter-icon"><i class="aside-filter-new"></i></div>
      </span>
    </el-tab-pane>
    <el-tab-pane name="table">
      <span slot="label">
        <div class="aside-filter-icon"><i class="aside-filter-table"></i></div>
      </span>
    </el-tab-pane>
    <el-tab-pane name="canceled">
      <span slot="label">
        <div class="aside-filter-icon"><i class="aside-filter-canceled"></i><span v-if="getNumberResasCancelled > 0"
            class="macaron">{{ getNumberResasCancelled }}</span></div>
      </span>
    </el-tab-pane>
    <el-tab-pane name="marketing">
      <span slot="label">
        <div class="aside-filter-icon"><i class="aside-filter-marketing"></i></div>
      </span>
    </el-tab-pane>
    <div id="resasToPrint" ref="scrollpane" class="el-tab-pane">
      <resa-line v-for="resaH in getResas" :key="resaH.id" v-bind:resa='resaH' />
    </div>
  </el-tabs>
  <transition name="fade">
    <popup-take-resa v-if="isVisiblePopupTakeResa" />
    <popup-create-room v-if="isVisiblePopupCreateRoom" />
  </transition>
</el-row>
